// CHANGED: only the helper is left. The old "View (n)" button + popup component
// (the default export) was removed because no screen uses it any more.
// REMOVED imports: React, createPortal, lucide-react icons, styles (not needed now).

// Same base the old ticket table uses: API base URL without the "/api" part.
const SERVER_BASE = (process.env.REACT_APP_API_BASE_URL || "").split("/api")[0];

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp)(\?.*)?$/i;
const PDF_EXT = /\.pdf(\?.*)?$/i;

// attachments can arrive as an array, a JSON string, a single object or a
// plain url string. Always return a clean array of
// { url, filename, isImage, isPdf }.
export const normalizeAttachments = (raw) => {
  let list = [];

  if (!raw) return [];
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      list = Array.isArray(parsed) ? parsed : [parsed];
    } catch (_e) {
      list = raw.trim() ? [raw.trim()] : [];
    }
  } else if (Array.isArray(raw)) {
    list = raw;
  } else if (typeof raw === "object") {
    list = [raw];
  }

  return list
    .map((item) => {
      const obj = typeof item === "string" ? { url: item } : item || {};
      const rawUrl = obj.url || "";
      if (!rawUrl) return null;
      const url = /^https?:\/\//i.test(rawUrl)
        ? rawUrl
        : `${SERVER_BASE}${rawUrl.startsWith("/") ? rawUrl : `/${rawUrl}`}`;
      const filename = obj.filename || rawUrl.split("/").pop() || "attachment";
      const type = String(obj.type || "");
      return {
        url,
        filename,
        isImage: type.startsWith("image/") || IMAGE_EXT.test(rawUrl),
        isPdf: type.includes("pdf") || PDF_EXT.test(rawUrl),
      };
    })
    .filter(Boolean);
};
